module.exports = __webpack_public_path__ + "img/A.7f2a03f9.jpg";